import { useTranslation } from 'react-i18next'
import { NotFoundContainer, ReservationButton } from './styled'
import warning from 'assets/icons/warning-icon.svg'

export default function RedirectCommonOffice({ handleRedirect }: { handleRedirect: () => void }) {
  const { t } = useTranslation()
  return (
    <NotFoundContainer>
      <img src={warning} width={120} height={120} alt="no-reservation" />
      <span className="warning-text">{t('park-area-res-modal.no-park-area')}</span>
      <ReservationButton onClick={handleRedirect}>{t('park-area-res-modal.make-common-office-res')}</ReservationButton>
    </NotFoundContainer>
  )
}
